import { render, staticRenderFns } from "./FrontCover.vue?vue&type=template&id=482dc11e&"
import script from "./FrontCover.vue?vue&type=script&lang=js&"
export * from "./FrontCover.vue?vue&type=script&lang=js&"
import style0 from "./FrontCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports